module.exports = __webpack_public_path__ + "static/google-partner-b52bffef75f4fd1cdb6ed7a38bb68992.png";